import { UserData } from 'types/User/unifiedLogin';

import { LoginStatus } from 'proto/User/Session';

export const API_PRODUCT = 'package';
export const ULI_EVENT_NAME = 'unified-login';

export enum LoginTheme {
    COLOR = 'color',
    LIGHT = 'light',
}

export enum DeviceOutput {
    Desktop = 'desktop',
    Tablet = 'tablet',
}

export enum LoginType {
    Default = '',
    Email = 'check24',
    Phone = 'check24_phone',
}

export enum PasswordResetType {
    Default = '',
    Email = 'email',
    Tan = 'tan',
}

export enum PointsType {
    Default = '',
    None = 'none',
    Checkbox = 'checkbox',
    Radio = 'radio',
}

export enum Context {
    Default = '',
    Checkout = 'as',
    CustomerArea = 'kb',
    LoginLayer = 'loginlayer',
}

export type Anonymous = boolean | 'register';

export interface LoginData {
    id?: string;
    deviceOutput?: DeviceOutput;
    loginEmail?: string;
    loginPhone?: string;
    loginType?: LoginType;
    redirectUrl?: string;
    passwordResetRedirectUrl?: string;
    passwordResetType?: PasswordResetType;
    points?: PointsType;
    basePath?: string;
    socialLoginClosingUrl?: string;
    socialLoginCallbackUrl?: string;
    socialLoginBaseUrl?: string;
    browserBack?: 'always' | '';
    isLocalSession?: boolean;
    customParam?: string;
    configKey?: string;
    anonymous?: Anonymous;
    responsive?: boolean;
    mainWidth?: number;
    helpWidth?: number;
    border?: 'none' | '';
    background?: 'grey' | '';
    context?: Context;
    // loginMode?: 'code';
}

export interface LoginEvent {
    sessionId: string;
    loginStatus: LoginStatus;
}

export type UnifiedLoginEventType = {
    ul: UserData;
};

interface GuestUserPostData {
    guestEmail: string;
    guestPhone: string;
}

export interface LoginUserPostData {
    session?: string;
    pointsDecision?: string;
    loginType?: string;
    loginEnv?: string;
    loginServer?: string;
}

export type UserPostRequest = GuestUserPostData | LoginUserPostData;

export interface UserPostResponse {
    status: 'success' | 'error';
}
